/**
 * Builds the absolute path of a settings section. Settings routes mount under
 * `/practices/:practiceId/settings`, and a section's `to` is relative to that route.
 *
 * @param practiceId - The practice whose settings to open.
 * @param to - The section path relative to the settings route, such as `forms/`.
 * @returns The path with no trailing slash, such as `/practices/abc/settings/forms`; an empty `to`
 * gives the settings root.
 */
export function buildSettingsPath(practiceId: string, to: string): string {
  const section = to.replace(/^\/+|\/+$/g, "");
  const settingsPath = `/practices/${practiceId}/settings`;
  if (section === "") return settingsPath;
  return `${settingsPath}/${section}`;
}
